import { MotiView } from "moti";
import React, { ReactElement, useEffect, useState } from "react";

import { Box, Pressable } from "@whoosh/design-system/src/components/primitive";

import { ChevronDownIcon } from "../../icons_v2/general";
import { AnimateHeight } from "./AnimateHeight";

type AccordionProps = {
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  header: ReactElement<any, any>;
  children?: any;
  testID?: string;
  hideIcon?: boolean;
  isDisabled?: boolean;
};

const Accordion = ({
  isOpen,
  onOpenChange,
  children,
  header,
  testID,
  hideIcon,
  isDisabled,
}: AccordionProps) => {
  const [open, setOpen] = useState(isOpen || false);

  useEffect(() => {
    if (onOpenChange) onOpenChange(open);
  }, [open, onOpenChange]);

  useEffect(() => {
    if (isOpen !== null) setOpen(!!isOpen);
  }, [isOpen]);

  return (
    <Box>
      <Pressable
        onPress={() => setOpen(!open)}
        disabled={isDisabled}
        flexDirection="row"
        alignItems="center"
        testID={testID}
        pr={hideIcon ? 0 : 3}
      >
        <Box flex={1} style={{ paddingRight: -12 }}>
          {header}
        </Box>
        {!hideIcon && (
          <MotiView
            animate={{
              rotate: open ? "-180deg" : "0deg",
            }}
            transition={{
              rotate: {
                type: "timing",
                duration: 300,
              },
            }}
          >
            <ChevronDownIcon accessible={false} />
          </MotiView>
        )}
      </Pressable>
      <AnimateHeight enterFrom="bottom" hide={!open}>
        {open ? children : null}
      </AnimateHeight>
    </Box>
  );
};

export default Accordion;
